import { useState } from 'react';
import { MapView } from '../features/map/MapView.js';
import {
  HistoricalView,
  currentHistoricalWeek,
  DEFAULT_HISTORICAL_YEAR,
} from '../features/historical/HistoricalView.js';
import type { MapMode } from '../features/map/types.js';

export function MapPage() {
  const [mode, setMode] = useState<MapMode>('wbgt');
  // Owned here (not in HistoricalView) so the past-mode year/week selection
  // survives switching to WBGT / forecast and back. First open defaults to the
  // current system date's week in the latest season year.
  const [histYear, setHistYear] = useState<string>(DEFAULT_HISTORICAL_YEAR);
  const [histWeek, setHistWeek] = useState<number>(() => currentHistoricalWeek());

  return (
    <div className="h-full">
      {mode === 'historical' ? (
        <HistoricalView
          mode={mode}
          onModeChange={setMode}
          year={histYear}
          weekIdx={histWeek}
          onYearChange={setHistYear}
          onWeekChange={setHistWeek}
        />
      ) : (
        <MapView mode={mode} onModeChange={setMode} />
      )}
    </div>
  );
}
